export default __webpack_public_path__ + "static/media/ExperienceStars.e4d51cac.png";